import { ColDef } from 'ag-grid-community';

import { DistributorList } from 'src/app/shared/models/constants';
import { ItemThumbnailComponent } from 'src/app/shared/components/ag-grid/item-thumbnail/item-thumbnail.component';
import { DescriptionCellComponent } from 'src/app/shared/components/ag-grid/description-cell/description-cell.component';
import { FavoriteToggleComponent } from 'src/app/shared/components/ag-grid/favorite-toggle/favorite-toggle.component';

export const LiveInventoryColumnDef: ColDef[] = [
  { // Item UPC
    headerName: 'Item UPC',
    field: 'upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
    pinned: 'left',
    cellClass: (params) => {
      const data = params.data;
      if (!data) return '';
      try {
        const distributors = DistributorList.map(d => {
          if (d.name === 'cssi') return 'chattanooga';
          if (d.name === 'allen_arms_tactical') return 'allen_arms';
          return d.name;
        });
        const hasStock = distributors.some(dist => {
          const qty = data[`${dist}_available_qty`];
          if (qty) {
            const numQty = parseInt(qty.toString().replace('+', ''), 10);
            return numQty > 0;
          }
          return false;
        });
        return hasStock ? '' : '';
      } catch (e) {
        return '';
      }
    },
    cellRenderer: (params: any) => {
      const upc = params.value || '';
      const data = params.data;
      
      if (!data) return `<span>${upc}</span>`;
      
      const getDot = (distName: string, prefix: string, colorClass: string) => {
        const qty = data[`${prefix}_available_qty`];
        if (qty) {
          const numQty = parseInt(qty.toString().replace('+', ''), 10);
          if (numQty > 0) {
            return `<i class="fa-solid fa-circle distributor-dot ${colorClass}" title="${distName}"></i>`;
          }
        }
        return '';
      };

      try {
        const componentParent = params.context?.componentParent;
        const dots = DistributorList
          .filter((d: any) => d.inventory && d.dotClass)
          .filter((d: any) => {
            if (!componentParent || typeof componentParent.isDistributorActive !== 'function') return true;
            return componentParent.isDistributorActive(d.name);
          })
          .map((d: any) => {
            let prefix = d.name;
            if (d.name === 'cssi') prefix = 'chattanooga';
            if (d.name === 'allen_arms_tactical') prefix = 'allen_arms';
            return getDot(d.label || d.name, prefix, d.dotClass);
          })
          .join('');

        return `<div class="d-flex flex-column justify-content-center h-100"><span>${upc}</span><div class="d-flex gap-1">${dots}</div></div>`;
      } catch (e) {
        return `<span>${upc}</span>`;
      }
    }
  },
  { // Image
    colId: 'image',
    headerName: 'Image',
    field: 'upc',
    resizable: true,
    sortable: false,
    filter: false,
    width: 140,
    pinned: 'left',
    cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    cellRenderer: ItemThumbnailComponent,
  },
  { // Manufacture
    headerName: 'Manufacture',
    field: 'manufacturer',
    resizable: true,
    width: 135,
    filter: 'agTextColumnFilter',
  },
  { // Description + MFG Part Number
    colId: 'description_mfg_part',
    headerName: 'Description',
    field: 'desc1',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
    filterValueGetter: (params) =>
      `${params.data?.desc1 || ''} ${params.data?.mfg_part_number || ''}`,
    cellRenderer: DescriptionCellComponent,
  },
  // { // Additional Information
  //   headerName: 'Additional Information',
  //   resizable: true,
  //   width: 200,
  //   filter: 'agTextColumnFilter',
  //   valueGetter: (params) => 'Additional Information',
  //   tooltipValueGetter: (params) => params.data?.upc || ' ',
  //   tooltipComponent: ItemSpecTooltipComponent,
  // },
  { // Favorite
    colId: 'favorite',
    headerName: 'Favorite',
    field: 'favorite',
    resizable: true,
    sortable: true,
    filter: false,
    width: 100,
    cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    cellRenderer: FavoriteToggleComponent,
  },
  { // MSRP Price
    headerName: 'MSRP Price',
    field: 'msrp',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    pinned: 'right',
    valueGetter: (params) => params.data.map_price ? parseFloat(params.data.map_price) : null,
    valueFormatter: (params) => typeof params.value === 'number' ? `$${params.value.toFixed(2)}` : params.value,
  },
  { // MAP Price
    headerName: 'MAP Price',
    field: 'map_price',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    pinned: 'right',
    cellStyle: {color: 'lightcoral'},
    valueGetter: (params) => params.data.map_price ? parseFloat(params.data.map_price) : null,
    valueFormatter: (params) => typeof params.value === 'number' ? `$${params.value.toFixed(2)}` : params.value,
  },
];
